var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 60,
    transform: "rotate(-180 97 97)",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 79,
    transform: "rotate(15 97 97)",
    stroke: "#F1F1F1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.3 98.9984H105.174V97.124H103.3V98.9984ZM106.424 98.9984H108.298V97.124H106.424V98.9984Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6992 128.984L74.0262 123.28V70.7113L95.6992 65.0078V128.984ZM93.8248 67.439L75.9003 72.1561V121.835L93.8248 126.552V67.439Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0062 96.9962C85.0062 95.1656 86.4953 93.6758 88.3263 93.6758C90.1572 93.6758 91.6467 95.1656 91.6467 96.9962C91.6467 98.8272 90.1572 100.317 88.3263 100.317C86.4953 100.317 85.0062 98.8272 85.0062 96.9962ZM86.8806 96.9962C86.8806 97.7939 87.5293 98.4422 88.3263 98.4422C89.124 98.4422 89.7727 97.7939 89.7727 96.9962C89.7727 96.1989 89.124 95.5506 88.3263 95.5506C87.5293 95.5506 86.8806 96.1989 86.8806 96.9962Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.85 89.4976H108.724V71.1729H98.198V73.0473H106.85V89.4976Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.85 120.945H98.198V122.82H108.724V106.702H106.85V120.945Z",
    fill: "#9B9B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.458 98.0995L112.74 85.3965V92.0588H98.198V93.9333H114.615V89.1743L126.36 98.0995L114.615 107.025V102.267H98.198V104.141H112.74V110.803L129.458 98.0995Z",
    fill: "#4A4A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.798 89.4973H104.672V75.2246H98.198V77.099H102.798V89.4973Z",
    fill: "#9B9B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.672 106.702H102.798V116.893H98.198V118.767H104.672V106.702Z",
    fill: "#9B9B9B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.819041b051695ed67dda41156890f39d.svg";